export const validateAccount = async (uid) => {
    function _getValidateUrl() {
        const prefix = isDev() ? "http://localhost:8788/" : "";
        return `${prefix}api/validate-uid`;
    }
    const urlParams = new URLSearchParams({uid});
    const res = await fetch(_getValidateUrl() + `?${urlParams.toString()}`);
    if (res.status === 200) {
        const responseJson = await res.json();
        return responseJson.success;
    } else {
        return false;
    }
}

export function isDev() {
    return process.env?.NODE_ENV === "development";
}

export function getApiUrl() {
    const prefix = isDev() ? "http://localhost:8788/" : "";
    return `${prefix}api/generate-payment-link`;
}

export function getCountryUrl() {
    const prefix = isDev() ? "http://localhost:8788/" : "";
    return `${prefix}api/country`;
}
